import { rootApi } from '../api/rootApi';
import { getApi } from '../api/getApi';
import { postApi } from '../api/postApi';

export const toursService = {
    getAllTours: async () => {
        return await getApi(rootApi.tours);
    },
    getTourById: async (id) => {
        return await getApi(`${rootApi.tours}/${id}`);
    },
    addTour: async (data) => {
        return await postApi(rootApi.tours, data);
    }
};
